/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import {
    Stashboard,
    useI18n,
    useSpringBigStore,
    useStashboards,
    useAppSettings,
    Member,
    StashboardKey,
    handleDate,
} from '@springbig/shared';

import Section from '~/shared/Section';

import MessageCarousel from './components/MessagesCarousel';
import NoDataView from '~/shared/NoData';
import { useAuthorization } from '~/hooks/auth';
import Loading from '~/shared/Loading';
import { orderBy } from "lodash";
import { NoDataPlaceholder } from '~/shared/NoDataPlaceholder';
import { faMessage } from '@fortawesome/free-solid-svg-icons';
import { Box, Center, HStack, Icon, Skeleton, VStack } from 'native-base';

dayjs.extend(relativeTime);

const MessageListScreen = () => {

    const [items, setItems] = useState<Stashboard[]>([]);
    const { fetch, isLoading } = useStashboards();
    const { isLoadingAuth, authError } = useAuthorization();
    const { t } = useI18n();
    const { member, stashboards, stashboardKeys } = useSpringBigStore();
    const {
        expirationDateInDays
    } = useAppSettings();

    useEffect(() => {

        if (!authError && member && !isLoadingAuth && (!items || !items.length)) {
            fetch();
        }
    }, [member, isLoadingAuth, authError]);

    const filterStashboard = (member: Member | null | undefined, stashboards: Stashboard[] | undefined, stashboardKeys: StashboardKey[] | undefined, expirationDateInDays: number | undefined) => {

        if (!stashboards || !stashboards?.length) {
            return;
        }

        const filtered = stashboards.filter(item => (

            item.merchant_id * 1 === member?.merchant_id
        ));


        const alreadyFetched = filtered?.map((k) => k._key);
        const oldKeys = stashboardKeys?.filter((k) => alreadyFetched?.includes(k.stashboard_key));
        const validStashboardKeys = oldKeys?.filter((key) => !!handleDate(expirationDateInDays, key.epoch));
        const _stashboards = stashboards?.filter((s) => validStashboardKeys?.map((k) => k.stashboard_key).includes(s._key));
        return orderBy(_stashboards,
            ['sent_at'],
            ['desc']);
    };

    useEffect(() => {
        if (!isLoading && stashboards && stashboards.length > 0) {
            const filteredStashboard = filterStashboard(member, stashboards, stashboardKeys, expirationDateInDays);
            filteredStashboard && setItems(filteredStashboard);
        }
    }, [isLoading])

    const isInitialLoading = isLoading || isLoadingAuth || (!member || !stashboards ||(stashboards.length > 0 && !(items && items.length > 0)));
    const noItemsAvailable = (!items || !(items && items.length > 0) ) && member && !(isLoading || isLoadingAuth);

    if (isInitialLoading) {
        return (
            <>
                <MessagesSkeleton />
                <MessagesSkeleton />
            </>
        );
    }

    if (noItemsAvailable) {
        return <NoDataPlaceholder
            title={t("common.messages_placeholder_title")}
            message={t("common.messages_placeholder_subtitle")}
            callback={fetch}
            isLoading={isLoading}
            iconName={faMessage}
        />
    }

    return (
        <Section
            pb={10}
            display={'block'}
            flex={1}
            w={'100%'}
            overflowY={'auto'}
            overflowX={'hidden'}
        >

            {items.length > 0 && items.map((data,
                index) => {

                return (
                    <MessageCarousel
                        key={`${index}-stashboard`}
                        data={data}
                        hasMoreContent
                    />
                );
            })
            }
        </Section>
    );
};

const MessagesSkeleton = () => {
    return (
        <VStack width="100%" space={2} mt={4}>
            <Center flex={1}>
                <Skeleton height={3} width="60%" my={2} rounded={'md'} />
                <Skeleton height={400} width="100%" />
                <Skeleton height={3} width="60%" my={6} rounded={'md'} />
            </Center>
            <HStack space="4">
                <Skeleton flex="1" h="75" rounded="md" />
                <Skeleton flex="1" h="75" rounded="md" />
            </HStack>
        </VStack>
    );
};


export default MessageListScreen;